// Status of the local files in the AppPackageEditor
export enum AppPackageEditorStatus {
  NotLoaded = "NotLoaded", // When server files are not loaded locally
  NoChanges = "NoChanges", // When server and local files are in sync
  ModifiedNotSaved = "ModifiedNotSaved", // When local files are modified but not saved
  LocalErrors = "LocalErrors", // When there are errors when locally validated
  ValidationErrors = "ValidationErrors", // When there are validation errors from server
  Saving = "Saving", // When local changes are being saved to server
  SavedSuccess = "SavedSuccess", // When local changes are saved to server successfully
  SavedFailed = "SavedFailed", // When local changes are not saved to server
  Error = "Error" // When there is an error in the editor
}

export enum AppPackageEditorFileTypes {
  Manifest = "Manifest",
  Icon = "AppIcon",
  OutLine = "AppOutLine",
  // We should only be defining file types by extensions which is defined below
  // but above files are of special types since there is
  // extra validation and restrictions on these files  
  // hence defined as their own type
  Json = "Json",
  Yaml = "Yaml",
  Png = "Png",
  Folder = "Folder",
  Unsupported = "Unsupported"
}

export const supportedImages = {
  [AppPackageEditorFileTypes.Icon]: {
    width: 192,
    height: 192,
    supportedFormats: [".png"]
  },
  [AppPackageEditorFileTypes.OutLine]: {
    width: 32,
    height: 32,
    supportedFormats: [".png"]
  }
};